export const xsmall = '(max-width: 539px)'
export const small = '(min-width: 540px) and (max-width: 1023px)'
export const smallUp = '(min-width: 540px)'
export const mediumUp = '(min-width: 1024px)'



// WEBPACK FOOTER //
// ./src/config/screen.js